/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { useLocation, useHistory } from "react-router-dom";
import api from "api";
import { toast } from "react-toastify";
import "../../assets/css/auth.css";

// /auth/team-accept?token=...
// Public page reached from a team-invite email. Sets the user's password
// and signs them in.
const TeamAccept = () => {
  const location = useLocation();
  const history = useHistory();

  const token = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("token") || "";
  }, [location.search]);

  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      toast.error("This invite link is missing a token.");
    }
  }, [token]);

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!token) {
      toast.error("Invite token missing.");
      return;
    }
    if (password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Passwords don't match.");
      return;
    }
    setLoading(true);
    try {
      const res = await api("post", "/users/team/accept", {
        token,
        password,
        name: name.trim() || undefined,
      });
      if (res?.success && res.token) {
        localStorage.setItem("token", res.token);
        toast.success("Welcome! Setting up your dashboard…");
        // All teammates have role: 'brand', so route to the brand layout.
        window.location = "/brand/index";
      } else {
        toast.error(res?.message || "Could not accept invite.");
      }
    } catch (_err) {
      // interceptor toasts
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-card">
      <div className="auth-card__header">
        <h2 className="auth-card__title">Accept your invite</h2>
        <p className="auth-card__subtitle">Set a password to join your team's VeriScan dashboard.</p>
      </div>
      <form onSubmit={handleSubmit} className="auth-card__form">
        <div className="auth-card__field">
          <label>Your name (optional)</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Leave blank to keep what your inviter set"
          />
        </div>
        <div className="auth-card__field">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            required
            minLength={8}
          />
        </div>
        <div className="auth-card__field">
          <label>Confirm password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            required
            minLength={8}
          />
        </div>
        <button type="submit" className="auth-card__submit" disabled={loading || !token}>
          {loading ? "Accepting…" : "Accept invite"}
        </button>
      </form>
    </div>
  );
};

export default TeamAccept;
